import { authHeader, accountHeader, BASE_URL, handleResponse } from '@helpers/api';
import { ProductEvent } from '@constants/product-events';
import { captureOnCreate, captureOnSuccess } from '@helpers/product-events';

function get(page, pageSize) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/coupons?page=${page}&pageSize=${pageSize}`, requestOptions).then(handleResponse);
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/coupons/lookups`, requestOptions).then(handleResponse);
}

function createOrUpdateCoupon(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/coupons`, requestOptions)
        .then(handleResponse)
        .then(captureOnCreate(data, ProductEvent.CouponCreated));
}

function updateCouponStatus(templateId, operation) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/coupons/${templateId}/${operation}`, requestOptions).then(handleResponse);
}

function uploadCouponImage(data) {
    const user = JSON.parse(localStorage.getItem('user'));
    const requestOptions = {
        method: 'POST',
        headers: {
            Authorization: 'Bearer ' + user.token,
            ...accountHeader(),
        },
        body: data,
    };
    return fetch(`${BASE_URL}api/coupons/upload-asset`, requestOptions).then(handleResponse);
}

function exportCSV(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(`${BASE_URL}api/coupons/export`, requestOptions)
        .then(handleResponse)
        .then(captureOnSuccess(ProductEvent.DataExported, { resource: 'coupons' }));
}

export const couponsService = {
    get,
    createOrUpdateCoupon,
    getAll,
    updateCouponStatus,
    uploadCouponImage,
    exportCSV,
};
